<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'FOOTER.SITEMAP_TITLE' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'FOOTER.SITEMAP_TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'FOOTER.SITEMAP_TEXT' | translate }}</p>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-sitemap-grid">
        <div *ngFor="let section of sections" class="ph-sitemap-col">
          <h3>{{ section.titleKey | translate }}</h3>
          <ul>
            <li *ngFor="let link of section.links">
              <a [routerLink]="link.route">{{ link.labelKey | translate }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</div>
